import { render } from "./PaymentSuccessStoreFaq.vue?vue&type=template&id=595658a2"
import script from "./PaymentSuccessStoreFaq.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessStoreFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__